/**
 * PWA chrome: an offline indicator and a "new version available" reload prompt.
 * Uses vite-plugin-pwa's virtual register-SW module.
 */
import { useEffect, useState } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { IconWifiOff, IconRefresh } from '@tabler/icons-react';
import { GlassPanel } from '../ui/Glass.tsx';
import { Button } from '../ui/Button.tsx';

export function PWAStatus() {
  const [online, setOnline] = useState(typeof navigator === 'undefined' ? true : navigator.onLine);
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  return (
    <>
      {!online && (
        <div className="fixed inset-x-0 top-0 z-[90] flex justify-center p-2">
          <span className="inline-flex items-center gap-2 rounded-full border border-line bg-surface px-3 py-1 text-xs text-amber-600 shadow-md">
            <IconWifiOff className="h-3.5 w-3.5" /> Offline — showing cached photos
          </span>
        </div>
      )}

      {needRefresh && (
        <GlassPanel
          variant="strong"
          className="fixed bottom-5 left-5 z-[90] flex items-center gap-3 p-3"
        >
          <span className="text-sm text-fg">A new version is available.</span>
          <Button size="sm" variant="primary" onClick={() => updateServiceWorker(true)}>
            <IconRefresh className="h-4 w-4" /> Reload
          </Button>
          <Button size="sm" variant="ghost" onClick={() => setNeedRefresh(false)}>
            Later
          </Button>
        </GlassPanel>
      )}
    </>
  );
}
